var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "gooddetail",
      class: { "no-product": _vm.noProduct },
      attrs: { id: "page_Container" }
    },
    [
      !_vm.noProduct
        ? _c(
            "div",
            {
              staticClass: "page",
              class: { "video-show-page": _vm.videoShow }
            },
            [
              _vm.ajaxShow
                ? _c(
                    "div",
                    {
                      staticClass: "main-container",
                      attrs: { id: "main-container" }
                    },
                    [
                      _vm.productImages
                        ? _c(
                            "div",
                            { staticClass: "lunbo good-swiper" },
                            [
                              _c(
                                "van-swipe",
                                {
                                  ref: "proSwiper",
                                  on: { change: _vm.onChange }
                                },
                                [
                                  _vm.hasSwiperVideo
                                    ? _c("van-swipe-item", [
                                        _c(
                                          "video",
                                          {
                                            attrs: {
                                              id: "swiperBigVideo",
                                              controls: "",
                                              preload: "",
                                              "x5-video-player-type": "h5-page",
                                              poster: _vm.productImages[0],
                                              playsinline: ""
                                            }
                                          },
                                          [
                                            _c("source", {
                                              attrs: {
                                                src: _vm.swiperBigVideoSource,
                                                type: "video/mp4"
                                              }
                                            })
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.productImages, function(
                                    image,
                                    index
                                  ) {
                                    return _c(
                                      "van-swipe-item",
                                      {
                                        key: index,
                                        staticClass: "good-center"
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "good-img",
                                          attrs: { src: image }
                                        })
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "custom-indicator",
                                      attrs: { slot: "indicator" },
                                      slot: "indicator"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.hasSwiperVideo,
                                              expression: "hasSwiperVideo"
                                            }
                                          ],
                                          staticClass: "mr10",
                                          class: {
                                            "swiper-active":
                                              _vm.clickTagName === "player"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.changeSwiper("player")
                                            }
                                          }
                                        },
                                        [
                                          _c("van-icon", {
                                            attrs: { name: "play" }
                                          }),
                                          _vm._v("视频")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.hasSwiperVideo,
                                              expression: "hasSwiperVideo"
                                            }
                                          ],
                                          class: {
                                            "swiper-active":
                                              _vm.clickTagName === "photo"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.changeSwiper("photo")
                                            }
                                          }
                                        },
                                        [_vm._v("图片")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.clickTagName === "photo" ||
                                                !_vm.hasSwiperVideo,
                                              expression:
                                                "clickTagName==='photo'||!hasSwiperVideo"
                                            }
                                          ],
                                          staticClass: "indicator"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.hasSwiperVideo
                                                  ? _vm.current
                                                  : _vm.current + 1
                                              ) +
                                              "/" +
                                              _vm._s(_vm.productImages.length) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "cartPicFixed",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      _vm.gocartpage()
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../assets/img/goods/cartPic.png"),
                                      alt: ""
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "goods-detail" }, [
                        _vm.goodsdetildata.minPrice ===
                        _vm.goodsdetildata.maxPrice
                          ? _c("div", { staticClass: "goodsprice" }, [
                              _c(
                                "div",
                                { staticClass: "priceBox" },
                                [
                                  _c("p", { staticClass: "price-title" }, [
                                    _vm._v(
                                      "¥" +
                                        _vm._s(
                                          _vm.ESVBase.numberTofixed(
                                            _vm.goodsdetildata.minPrice
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.goodsdetildata.maxDeductionAmount
                                    ? _c("integralDeduction", {
                                        staticClass: "inteDetails",
                                        attrs: { goodData: _vm.goodsdetildata }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.goodsdetildata.minPriceMarket
                                ? _c("div", { staticClass: "marketprice" }, [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("价格:")
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "price" }, [
                                      _vm._v(
                                        "¥" +
                                          _vm._s(
                                            _vm.ESVBase.numberTofixed(
                                              _vm.goodsdetildata.minPriceMarket
                                            )
                                          )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.goodsdetildata.minPrice !==
                        _vm.goodsdetildata.maxPrice
                          ? _c("div", { staticClass: "goodsprice" }, [
                              _c(
                                "div",
                                { staticClass: "priceBox" },
                                [
                                  _c("p", { staticClass: "price-title" }, [
                                    _vm._v(
                                      "¥" +
                                        _vm._s(
                                          _vm.ESVBase.numberTofixed(
                                            _vm.goodsdetildata.minPrice
                                          )
                                        ) +
                                        "-" +
                                        _vm._s(
                                          _vm.ESVBase.numberTofixed(
                                            _vm.goodsdetildata.maxPrice
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.goodsdetildata.maxDeductionAmount
                                    ? _c("integralDeduction", {
                                        staticClass: "inteDetails",
                                        attrs: { goodData: _vm.goodsdetildata }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.goodsdetildata.minPriceMarket
                                ? _c("div", { staticClass: "marketprice" }, [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("价格：")
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "price" }, [
                                      _vm._v(
                                        "¥" +
                                          _vm._s(
                                            _vm.ESVBase.numberTofixed(
                                              _vm.goodsdetildata.minPriceMarket
                                            )
                                          ) +
                                          "-" +
                                          _vm._s(
                                            _vm.ESVBase.numberTofixed(
                                              _vm.goodsdetildata.maxPriceMarket
                                            )
                                          )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "goodstitle" }, [
                          _vm._v(_vm._s(_vm.goodsdetildata.name))
                        ]),
                        _vm._v(" "),
                        _vm.goodsdetildata.caption
                          ? _c("p", { staticClass: "goodstitle2" }, [
                              _vm._v(_vm._s(_vm.goodsdetildata.caption))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "buydata" }, [
                          _c("span", { staticClass: "payNum" }, [
                            _vm._v(
                              _vm._s(
                                _vm.goodsdetildata.salesNum
                                  ? _vm.goodsdetildata.salesNum
                                  : 0
                              ) + "人付款"
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.goodsdetildata.goodPoint
                                  ? _vm.goodsdetildata.goodPoint
                                  : 0
                              ) + "%好评"
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "van-cell-group",
                            [
                              _c(
                                "van-cell",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.retailStoreProductFlag,
                                      expression: "retailStoreProductFlag"
                                    }
                                  ],
                                  staticClass: "cellStyle",
                                  attrs: { title: "", value: "" }
                                },
                                [
                                  _c("template", { slot: "title" }, [
                                    _c(
                                      "span",
                                      { staticClass: "custom-title" },
                                      [
                                        _vm._v(
                                          "最高赚¥" +
                                            _vm._s(
                                              _vm.goodsdetildata.maxStoreProfit
                                                ? _vm.goodsdetildata.maxStoreProfit.toFixed(
                                                    2
                                                  )
                                                : ""
                                            ) +
                                            "元"
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("template", { slot: "default" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "buttonBox",
                                        on: { click: _vm.fxDetailsUrlClick }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                分享去赚钱\n                            "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showAllCoupon
                        ? _c(
                            "div",
                            {
                              staticClass: "couponshell",
                              on: {
                                click: function($event) {
                                  _vm.Coupon()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "couponcontain",
                                  staticStyle: { display: "flex" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "couponcontain-left" },
                                    [_vm._v("优惠")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "couponcontain-right" },
                                    [
                                      _vm.activityList &&
                                      _vm.activityList.length != 0
                                        ? _c(
                                            "div",
                                            { staticClass: "flex couponp" },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "van-tag",
                                                    {
                                                      attrs: {
                                                        color:
                                                          "rgba(255,190,43,0.2)",
                                                        round: "",
                                                        "text-color": "#FFBE2B"
                                                      }
                                                    },
                                                    [_vm._v("优惠活动")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.activityListFirst,
                                                    function(list, idx) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: idx <= 1,
                                                              expression:
                                                                "idx <= 1"
                                                            }
                                                          ],
                                                          key: idx,
                                                          staticClass:
                                                            "actFirst"
                                                        },
                                                        [_vm._v(_vm._s(list))]
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.minPoint
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "van-tag",
                                                {
                                                  attrs: {
                                                    color:
                                                      "rgba(238,46,80,0.2)",
                                                    round: "",
                                                    "text-color": "#EE2E50"
                                                  }
                                                },
                                                [_vm._v("积分")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "integral-item"
                                                },
                                                [
                                                  _vm._v(
                                                    "购买可得" +
                                                      _vm._s(_vm.minPoint) +
                                                      "积分起"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.goodsdetildata
                                                  .groupProductQuantity &&
                                                _vm.goodsdetildata
                                                  .groupProductQuantity !== 0,
                                              expression:
                                                "goodsdetildata.groupProductQuantity && goodsdetildata.groupProductQuantity!== 0"
                                            }
                                          ]
                                        },
                                        [
                                          _c(
                                            "van-tag",
                                            {
                                              attrs: {
                                                color: "rgba(238,46,80,0.2)",
                                                round: "",
                                                "text-color": "#EE2E50"
                                              }
                                            },
                                            [_vm._v("套装")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "integral-item" },
                                            [
                                              _vm._v(
                                                "该商品共有" +
                                                  _vm._s(
                                                    _vm.goodsdetildata
                                                      .groupProductQuantity
                                                  ) +
                                                  "个优惠套装"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.goodsdetildata
                                                  .genericCouponList &&
                                                _vm.goodsdetildata
                                                  .genericCouponList.length !==
                                                  0,
                                              expression:
                                                "goodsdetildata.genericCouponList && goodsdetildata.genericCouponList.length!== 0"
                                            }
                                          ]
                                        },
                                        [
                                          _c(
                                            "van-tag",
                                            {
                                              attrs: {
                                                color: "rgba(238,46,80,0.2)",
                                                round: "",
                                                "text-color": "#EE2E50"
                                              }
                                            },
                                            [_vm._v("优惠")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "integral-item" },
                                            [
                                              _vm._v(
                                                "该商品共有" +
                                                  _vm._s(
                                                    _vm.goodsdetildata
                                                      .genericCouponList
                                                      ? _vm.goodsdetildata
                                                          .genericCouponList
                                                          .length
                                                      : 0
                                                  ) +
                                                  "张优惠券"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "couponcontain-right-arrows right-arrows"
                                    },
                                    [_vm._v("查看")]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sku
                        ? _c(
                            "div",
                            {
                              staticClass: "specifications",
                              on: {
                                click: function($event) {
                                  _vm.specifications()
                                }
                              }
                            },
                            [
                              _c("P", [
                                _c("span", { staticStyle: { float: "left" } }, [
                                  _vm._v("规格")
                                ]),
                                _vm._v(" "),
                                _vm.selectedStyles.length !==
                                _vm.specificationNum
                                  ? _c("span", { staticClass: "notchoosed" }, [
                                      _vm._v("选择")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.selectedStyles.length ===
                                _vm.specificationNum
                                  ? _c("span", { staticClass: "choosed" }, [
                                      _vm._v(_vm._s(_vm.selectedStylesString))
                                    ])
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "specifications sku-wrapper" },
                        [
                          _c("van-sku", {
                            ref: "vanSku",
                            staticClass: "sku-container descBox",
                            attrs: {
                              sku: _vm.sku,
                              "initial-sku": _vm.initialSku,
                              goods: _vm.goods,
                              "goods-id": _vm.goodsId,
                              "hide-stock": false,
                              quota: _vm.quota,
                              "quota-used": _vm.quotaUsed,
                              "reset-stepper-on-hide": _vm.resetStepperOnHide,
                              "reset-selected-sku-on-hide":
                                _vm.resetSelectedSkuOnHide,
                              "close-on-click-overlay": _vm.closeOnClickOverlay,
                              "disable-stepper-input": _vm.disableStepperInput,
                              "custom-stepper-config": _vm.customStepperConfig
                            },
                            on: {
                              "add-cart": _vm.onAddCartClicked,
                              "buy-clicked": _vm.onBuyClicked,
                              "sku-selected": _vm.onSkuSelected
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "van-sku-stepper-stock",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "van-sku-stepper-container"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "van-sku__price-symbol"
                                          },
                                          [_vm._v("￥")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "van-sku__price-num" },
                                          [_vm._v(_vm._s(props.price))]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "sku-actions",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "van-sku-actions" },
                                      [
                                        _vm.isgocart === 1 || _vm.isgocart === 2
                                          ? _c(
                                              "van-button",
                                              {
                                                staticClass: "determine-btn",
                                                attrs: {
                                                  type: "primary",
                                                  "bottom-action": ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    props.skuEventBus.$emit(
                                                      "sku:buy"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("确定")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isgocart === 0
                                          ? _c(
                                              "van-button",
                                              {
                                                staticClass: "left-btn",
                                                attrs: {
                                                  type: "primary",
                                                  "bottom-action": "",
                                                  disabled:
                                                    Number(
                                                      _vm.goodsdetildata.type
                                                    ) === 4
                                                },
                                                on: {
                                                  click: function($event) {
                                                    props.skuEventBus.$emit(
                                                      "sku:addCart"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("加入购物车")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isgocart === 0
                                          ? _c(
                                              "van-button",
                                              {
                                                staticClass: "right-btn",
                                                attrs: {
                                                  type: "primary",
                                                  "bottom-action": "",
                                                  disabled:
                                                    Number(
                                                      _vm.goodsdetildata.type
                                                    ) === 4
                                                },
                                                on: {
                                                  click: function($event) {
                                                    props.skuEventBus.$emit(
                                                      "sku:buy"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("立即购买")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.showBase,
                              callback: function($$v) {
                                _vm.showBase = $$v
                              },
                              expression: "showBase"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.productParameterList.length != 0
                        ? _c(
                            "div",
                            {
                              staticClass: "parameter",
                              on: {
                                click: function($event) {
                                  _vm.parame()
                                }
                              }
                            },
                            [
                              _c("p", [
                                _vm._v("参数\n                    "),
                                _c("span", { staticClass: "notchoosed" }, [
                                  _vm._v(
                                    _vm._s(_vm.productParameterList[0].key) +
                                      "..."
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productComment.accountAvatar
                        ? _c(
                            "div",
                            {
                              class: [
                                "evaluation",
                                { evaluation2: _vm.introduction.length === 0 }
                              ]
                            },
                            [
                              _c("div", { staticClass: "evatitle" }, [
                                _c("span", [
                                  _vm._v(
                                    "商品评价（" +
                                      _vm._s(_vm.goodsdetildata.contentNum) +
                                      "）"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "evatitle-right" }, [
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.goevaluation(_vm.productId)
                                        }
                                      }
                                    },
                                    [_vm._v("查看全部")]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("evaluationCommon", {
                                attrs: {
                                  productComment: _vm.productComment,
                                  goodsdetildata: _vm.goodsdetildata,
                                  productId: _vm.productId,
                                  evabuttonFlag: true,
                                  imgShow: false,
                                  changeFlag: false,
                                  showRate: true,
                                  isLimit: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.introduction && _vm.introduction.length !== 0
                        ? _c(
                            "div",
                            { staticClass: "detailimg" },
                            [
                              _vm._m(0),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "detailimgContent" },
                                [
                                  _c(
                                    "video",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.detailVideoSource,
                                          expression: "detailVideoSource"
                                        }
                                      ],
                                      attrs: {
                                        id: "detailVideo",
                                        controls: "",
                                        preload: "",
                                        "x5-video-player-type": "h5-page",
                                        playsinline: ""
                                      }
                                    },
                                    [
                                      _c("source", {
                                        attrs: {
                                          src: _vm.detailVideoSource,
                                          type: "video/mp4"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.introduction, function(img) {
                                    return _c("img", {
                                      directives: [
                                        {
                                          name: "lazy",
                                          rawName: "v-lazy",
                                          value: img,
                                          expression: "img"
                                        }
                                      ],
                                      key: img.index,
                                      on: {
                                        click: function($event) {
                                          _vm.showBigDetaileImg(img)
                                        }
                                      }
                                    })
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.finishedOk ? _c("listBottom") : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.ajaxShow
                ? _c("div", [
                    _vm.showCoupon === false &&
                    _vm.showBase === false &&
                    _vm.showParameter === false
                      ? _c(
                          "div",
                          { staticClass: "downtab" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "homebtn btn",
                                on: { click: _vm.gohome }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../assets/img/home/downtab/home@3x.png"),
                                    alt: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", [_vm._v("首页")])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "collectbtn btn",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.collection($event)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      _vm.active === 1
                                        ? _vm.icon.active
                                        : _vm.icon.normal,
                                    alt: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", [_vm._v("收藏")])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "collectbtn btn",
                                on: { click: _vm.goService }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        _vm.contactCustomer +
                                        "&commodityid=" +
                                        _vm.goodsdetildata.productId
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: { src: _vm.icon.kf, alt: "" }
                                    }),
                                    _vm._v(" "),
                                    _c("p", [_vm._v("客服")])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "van-button",
                              {
                                staticClass: "gobuybtn eventbtn btn",
                                attrs: {
                                  type: "primary",
                                  "bottom-action": "",
                                  disabled:
                                    Number(_vm.goodsdetildata.type) === 4
                                },
                                on: { click: _vm.gobuy }
                              },
                              [_vm._v("立即购买")]
                            ),
                            _vm._v(" "),
                            _c(
                              "van-button",
                              {
                                staticClass: "gocartbtn eventbtn btn",
                                attrs: {
                                  type: "primary",
                                  "bottom-action": "",
                                  disabled:
                                    Number(_vm.goodsdetildata.type) === 4
                                },
                                on: { click: _vm.gocart }
                              },
                              [_vm._v("加入购物车")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showCoupon,
                      expression: "showCoupon"
                    }
                  ],
                  staticClass: "couponshell"
                },
                [
                  _c(
                    "div",
                    { staticClass: "couponcontain" },
                    [
                      _c(
                        "van-popup",
                        {
                          attrs: {
                            position: "bottom",
                            "close-on-click-overlay": _vm.closeOnClickOverlay
                          },
                          model: {
                            value: _vm.showCoupon,
                            callback: function($$v) {
                              _vm.showCoupon = $$v
                            },
                            expression: "showCoupon"
                          }
                        },
                        [
                          _c("div", { staticClass: "paratitle" }, [
                            _vm._v("优惠")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "promotion-wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "sale-promotion-wrapper" },
                              [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v("促销")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "activicontent" }, [
                                  _vm.activityList &&
                                  _vm.activityList.length >= 1
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "sale-promotion right-arrows",
                                          on: {
                                            click: function($event) {
                                              _vm.goActivity(
                                                _vm.activityListnew[0]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "mr-6" },
                                            [
                                              _c(
                                                "van-tag",
                                                {
                                                  attrs: {
                                                    color:
                                                      "rgba(238,46,80,0.2)",
                                                    round: "",
                                                    "text-color": "#EE2E50"
                                                  }
                                                },
                                                [_vm._v("活动")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "activiall" },
                                            [
                                              _vm._l(
                                                _vm.activityListnew[0].actname,
                                                function(name, idx) {
                                                  return [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          idx < 1
                                                            ? name + "，"
                                                            : idx === 1
                                                            ? name
                                                            : ""
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.activityListnew[0]
                                                      .timerange
                                                  )
                                                )
                                              ])
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.couponList && _vm.couponList.length !== 0
                                    ? _c(
                                        "div",
                                        { staticClass: "couponcontentshell" },
                                        _vm._l(_vm.couponList, function(item) {
                                          return _c(
                                            "div",
                                            {
                                              key: item.index,
                                              class: {
                                                "coupon-diabled":
                                                  item.receiveCouponNum === 0,
                                                coupon: true,
                                                clearfix: true
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "couponcontent"
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    { staticClass: "num" },
                                                    [
                                                      _vm._v(
                                                        "￥\n                                                "
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.faceAmount
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "numFonts"
                                                        },
                                                        [_vm._v("优惠券")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    { staticClass: "limit" },
                                                    [
                                                      _vm._v(
                                                        "满" +
                                                          _vm._s(
                                                            item.thresholdAmount
                                                          ) +
                                                          "元可使用"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  item.couponValidityType ===
                                                    "2" &&
                                                  item.couponValidityStart &&
                                                  item.couponValidityEnd
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "period"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "有效期:" +
                                                              _vm._s(
                                                                item.couponValidityStart.substring(
                                                                  0,
                                                                  10
                                                                )
                                                              ) +
                                                              "~" +
                                                              _vm._s(
                                                                item.couponValidityEnd.substring(
                                                                  0,
                                                                  10
                                                                )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.couponValidityType ===
                                                  "1"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "period"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "领取后" +
                                                              _vm._s(
                                                                item.couponValidityDay
                                                              ) +
                                                              "天内有效"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "couponbtn",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.receiveCoupon(item)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("立即领取")
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.goodsdetildata
                                            .groupProductQuantity &&
                                          _vm.goodsdetildata
                                            .groupProductQuantity !== 0,
                                        expression:
                                          "goodsdetildata.groupProductQuantity && goodsdetildata.groupProductQuantity!== 0"
                                      }
                                    ],
                                    staticClass:
                                      "sale-promotion couponp right-arrows",
                                    on: {
                                      click: function($event) {
                                        _vm.esvOpenPage({
                                          name: "OPGroupList",
                                          params: {
                                            productId:
                                              _vm.goodsdetildata.productId,
                                            spreadingCode: _vm.spreadingCode
                                          }
                                        })
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "mr-6" },
                                      [
                                        _c(
                                          "van-tag",
                                          {
                                            attrs: {
                                              color: "rgba(238,46,80,0.2)",
                                              round: "",
                                              "text-color": "#EE2E50"
                                            }
                                          },
                                          [_vm._v("套装")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        "该商品共有" +
                                          _vm._s(
                                            _vm.goodsdetildata
                                              .groupProductQuantity
                                          ) +
                                          "个优惠套装"
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.minPoint
                                  ? _c(
                                      "div",
                                      { staticClass: "sale-promotion" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "mr-6" },
                                          [
                                            _c(
                                              "van-tag",
                                              {
                                                attrs: {
                                                  color: "rgba(238,46,80,0.2)",
                                                  round: "",
                                                  "text-color": "#EE2E50"
                                                }
                                              },
                                              [_vm._v("积分")]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "content" }, [
                                          _vm._v(
                                            "购买可得" +
                                              _vm._s(_vm.minPoint) +
                                              "积分起"
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "myPoint" }, [
                                          _vm._v(
                                            "已有积分：" +
                                              _vm._s(_vm.totalPoint || 0)
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.genericCouponList &&
                            _vm.genericCouponList.length !== 0
                              ? _c(
                                  "div",
                                  { staticClass: "sale-promotion-wrapper" },
                                  [
                                    _c("div", { staticClass: "title" }, [
                                      _vm._v("优惠券")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "couponcontentshell" },
                                      _vm._l(_vm.genericCouponList, function(
                                        item
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: item.index,
                                            class: {
                                              "coupon-diabled":
                                                item.receiveCouponNum === 0,
                                              coupon: true,
                                              clearfix: true
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "couponcontent" },
                                              [
                                                item.couponType === "5"
                                                  ? _c(
                                                      "p",
                                                      { staticClass: "num" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.faceAmount
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "折\n                                            "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "numFonts"
                                                          },
                                                          [_vm._v("优惠券")]
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "p",
                                                      { staticClass: "num" },
                                                      [
                                                        _vm._v(
                                                          "￥\n                                            "
                                                        ),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.faceAmount
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "numFonts"
                                                          },
                                                          [_vm._v("优惠券")]
                                                        )
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  { staticClass: "limit" },
                                                  [
                                                    _vm._v(
                                                      "满" +
                                                        _vm._s(
                                                          item.thresholdAmount
                                                        ) +
                                                        "元可使用"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                item.couponValidityType ===
                                                  "2" &&
                                                item.couponValidityStart &&
                                                item.couponValidityEnd
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "period" },
                                                      [
                                                        _vm._v(
                                                          "有效期:" +
                                                            _vm._s(
                                                              item.couponValidityStart.substring(
                                                                0,
                                                                10
                                                              )
                                                            ) +
                                                            "~" +
                                                            _vm._s(
                                                              item.couponValidityEnd.substring(
                                                                0,
                                                                10
                                                              )
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.couponValidityType === "1"
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "period" },
                                                      [
                                                        _vm._v(
                                                          "领取后" +
                                                            _vm._s(
                                                              item.couponValidityDay
                                                            ) +
                                                            "天内有效"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "couponbtn",
                                                on: {
                                                  click: function($event) {
                                                    _vm.receiveCoupon(item)
                                                  }
                                                }
                                              },
                                              [_c("span", [_vm._v("立即领取")])]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "clickoff",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.clickoffCoupon()
                                }
                              }
                            },
                            [_vm._v("完成")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showParameter,
                      expression: "showParameter"
                    }
                  ],
                  staticClass: "parameter"
                },
                [
                  _c(
                    "van-popup",
                    {
                      attrs: {
                        position: "bottom",
                        "close-on-click-overlay": _vm.closeOnClickOverlay1
                      },
                      model: {
                        value: _vm.showParameter,
                        callback: function($$v) {
                          _vm.showParameter = $$v
                        },
                        expression: "showParameter"
                      }
                    },
                    [
                      _c("div", { staticClass: "paratitle" }, [
                        _vm._v("产品参数")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "attrsshell" },
                        _vm._l(_vm.productParameterList, function(item) {
                          return _c(
                            "div",
                            { key: item.index, staticClass: "attrs clearfix" },
                            [
                              _c("span", { staticClass: "attr" }, [
                                _vm._v(_vm._s(item.key))
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "content" }, [
                                _vm._v(_vm._s(item.value))
                              ])
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "clickoff",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.clickoffbtn()
                            }
                          }
                        },
                        [_vm._v("完成")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-popup",
                {
                  staticClass: "shadow",
                  model: {
                    value: _vm.shadowShow,
                    callback: function($$v) {
                      _vm.shadowShow = $$v
                    },
                    expression: "shadowShow"
                  }
                },
                [
                  _vm.shadowShow
                    ? _c("div", { staticClass: "shadow" }, [
                        _c("img", {
                          staticClass: "shadowPicZx",
                          attrs: { src: _vm.shadowPicZx, alt: "" }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "shadowPicZxText",
                          attrs: { src: _vm.shadowPicZxText, alt: "" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "shadowBtn" }, [
                          _c(
                            "div",
                            [
                              _c(
                                "van-button",
                                {
                                  staticClass: "btnColor2",
                                  attrs: { type: "primary" },
                                  on: { click: _vm.cancelShadow }
                                },
                                [_vm._v("取消")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("van-image-preview", {
                attrs: { images: _vm.detailBigImg, showIndex: false },
                model: {
                  value: _vm.detailImgShow,
                  callback: function($$v) {
                    _vm.detailImgShow = $$v
                  },
                  expression: "detailImgShow"
                }
              })
            ],
            1
          )
        : _c("div", { staticClass: "no-product" }, [
            _c("img", {
              attrs: {
                src: require("../assets/img/myCenter/noProduct.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", [_vm._v("商品已下架")])
          ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detailimgtitle" }, [
      _c("span", [_vm._v("详情")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }